// js/custom-element/section/facet/facet-filters.js
if (!customElements.get('facet-filters')) {
  var FacetFilters = class extends DrawerContent {
    connectedCallback() {
      super.connectedCallback();
      this.delegate.on('change', '[name^="filter."]', this._onFilterChanged.bind(this));
      this.rootDelegate.on('click', '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
      if (this.alwaysVisible) {
        this.matchMedia = window.matchMedia(window.themeVariables.breakpoints.pocket);
        this.matchMedia.addListener(this._adjustDrawer.bind(this));
        this._adjustDrawer(this.matchMedia);
      }
    }
    get alwaysVisible() {
      return this.hasAttribute('always-visible');
    }
    _onFiltersCleared(event, target) {
      event.preventDefault();
      triggerEvent(this, 'facet:criteria-changed', { url: target.href });
    }
    _onFilterChanged() {
      const formData = new FormData(this.querySelector('#facet-filters-form'));
      const searchParamsAsString = new URLSearchParams(formData).toString();
      triggerEvent(this, 'facet:criteria-changed', { url: `${window.location.pathname}?${searchParamsAsString}` });
    }
    _adjustDrawer(match) {
      this.classList.toggle('drawer', match.matches);
      this.classList.toggle('drawer--from-left', match.matches);
    }
  };
  window.customElements.define('facet-filters', FacetFilters);
}
